import { useMutation } from '@apollo/client';
import { PATCH_CATEGORY_MUTATION } from '../../mutations';

export function usePatchCategoryMutation() {
    return useMutation( PATCH_CATEGORY_MUTATION );
}
